import { ReactElement } from 'react';
import { MenuItem } from '../../utils/interfaces/Menu';
import { NavBar, SocialMedias } from '../../NavBar/NavBar';
import { ColorPalettes } from '../LandingBlock/LandingBlock';

import './LandingNavbar.module.scss';

interface LandingNavbarProps {
  items: MenuItem[];
  colorPalette?: ColorPalettes;
  backgroundInvisible?: boolean;
  social?: SocialMedias;
  removeBoxShadow?: boolean;
  logo?: ReactElement;
}

export const LandingNavbar = ({
  items,
  colorPalette = 'unknown',
  backgroundInvisible = false,
  removeBoxShadow = false,
  social = null,
  logo = null,
}: LandingNavbarProps) => {
  return (
    <NavBar
      items={items}
      logo={logo}
      showNavigationWith="text"
      colorPalette={colorPalette}
      social={social}
      configuration={{
        backgroundInvisible,
        navbarOnTop: true,
        removeTitleLarge: true,
        removePadding: true,
        removeBoxShadow,
      }}
    />
  );
};
